









































































































import { Component, Vue } from "vue-property-decorator";

import { io } from "socket.io-client";
import Vuex from "vuex";
import store from "@/store";
import router from "@/router";
@Component({
  components: {},
})
export default class Home extends Vue {
  public clickedStart = false;
  public startGame() {
    this.clickedStart = true;

    const socket = io(process.env.VUE_APP_SERVER);
    store.commit("setSocket", socket);
    store.state.socket.on("room", (roomId: string) => {
       router.push({ path: `game/${roomId}`});
    });
  }
}
